module.exports = __webpack_public_path__ + "static/media/48269394_2308808272527684_4934577583816704000_o-thumb.5363922d.jpg";